import { ENTREGA } from '../const'

export default [
  // 闪送
  {
    path: ENTREGA.ORDER_SHARE_URL,
    name: 'entregaordershare',
    meta: {
      title: '闪送订单分享页',
      hideHeader: true,
      showFooter: false,
      signOutNoBackFeed: true,
      loginWithoutVerification: true,
      notCheckPl: true,
      unScrollTop: true, // 禁止规格页打开时页面滚动到顶部
    },
    component: () =>
      import(
        /* webpackChunkName: "entregaIndex" */
        '@/views/Entrega/OrderShare/index'
      ),
  },
];
